import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Menu } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { TRANS_KEY_FAVORITES } from '../../data';

export const FavoritesToggleButton: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Menu.Target>
      <Button
        aria-label={t(`${TRANS_KEY_FAVORITES}.LABEL`)}
        variant="outline"
        p={4}
      >
        <FontAwesomeIcon icon={faCaretDown} />
      </Button>
    </Menu.Target>
  );
};
